import { render, staticRenderFns } from "./CommercialUnitListDetails.vue?vue&type=template&id=c95f211e&"
import script from "./CommercialUnitListDetails.vue?vue&type=script&lang=js&"
export * from "./CommercialUnitListDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports